<template>
    <Card :class="{'border border-warning': !orderRefund.effective}">
        <div class="d-flex flex-row justify-content-between gap-5">
            <Center vertical>
                <div>
                    <div v-if="!orderRefund.effective" class="mb-2">
                        <Badge type="badge-warning" class="text-white">
                            <template v-slot:icon>
                                <i class="fas fa-clock"/>
                            </template>
                            Pending Return
                        </Badge>
                    </div>
                    <div>
                        <b>RMA-ID</b>: {{ orderRefund.meta?.return_metadata?.rmaId || 'Not Available' }}
                    </div>
                    <div>
                        <b>Reason</b>: {{ orderRefund.meta?.return_metadata?.returnReason || 'Not Available' }}
                    </div>
                </div>
            </Center>
            <Center vertical>
                <div class="d-flex flex-row gap-3">
                    <Center vertical class="line-height-md">
                        <div class="font-size-lg">
                            {{ orderRefund.quantity_refunded }}
                            <span> x </span>
                        </div>
                    </Center>
                    <div class="rounded bg-light-primary overflow-hidden">
                        <img class="h-45px w-45px" :src="orderItem.image_url" :alt="orderItem.title">
                    </div>
                    <Center vertical class="line-height-md">
                        <div class="font-weight-bold">
                            {{ orderItem.title }}
                        </div>
                        <div class="font-size-sm font-weight-light">
                            {{ orderItem.description || 'Description not available.' }}
                        </div>
                    </Center>
                </div>
            </Center>
            <Center vertical>
                <div>
                    <b>{{ orderItem.identifier_type.toUpperCase() }}</b>: {{ orderItem.identifier }}
                </div>
            </Center>
            <div class="d-flex flex-column justify-content-center">
                <div>
                    <div v-if="!orderRefund.effective" class="d-flex flex-column justify-content-center">
                        <div v-if="loading" class="pr-5">
                            <div class="spinner spinner-track spinner-warning"/>
                        </div>
                        <div v-else class="d-flex flex-column justify-content-center gap-1">
                            <OrderRefundAcceptModal :order-refund="orderRefund"
                                                    @submit="data => acceptReturn(data.quantity)"
                            />
                            <OrderRefundRejectModal :order-refund="orderRefund"
                                                    @submit="data => rejectReturn(data.reason, data.quantity)"
                            />
                        </div>
                    </div>
                    <button v-else class="btn btn-default" disabled>
                        Already processed
                    </button>
                </div>
                <!--                <div>-->
                <!--                    <i class="fas fa-info-circle" />-->
                <!--                    This return can not be returned directly to the store.-->
                <!--                </div>-->
            </div>
        </div>
    </Card>
</template>

<script>
import Card from "../../Cards/Card.vue";
import Center from "../../Layout/Center.vue";
import Badge from "../../Badge.vue";
import OrderRefundRejectModal from "./OrderRefundRejectModal.vue";
import OrderRefundAcceptModal from "./OrderRefundAcceptModal.vue";

export default {
    components: {OrderRefundAcceptModal, Badge, Center, Card, OrderRefundRejectModal},

    props: {
        order: Object,
        store: Object,
        orderRefund: {
            type: Object,
            default() {
                return {
                    order_id: '',
                    identifier_type: '',
                    identifier: '',
                    quantity_refunded: 0,
                    issuer_uid: null,
                    iteration: 0,
                    effective: false,
                    reference_id: null,
                    meta: {
                        type: '',
                        status: '',
                        return_metadata: {
                            rmaId: '',
                            returnReason: '',
                            invoiceInformation: null,
                            fulfillmentOrderId: null
                        },
                        return_shipping_info: {
                            pickupDateTime: {
                                date: '1970-02-18 08:21:30.000000',
                                timezone: 'Europe/Berlin',
                                timezoneType: 3
                            },
                            deliveryDateTime: {
                                date: '1991-02-02 04:57:58.000000',
                                timezone: 'Europe/Berlin',
                                timezoneType: 3
                            },
                            forwardTrackingInfo: {
                                trackingId: "TBA001798697",
                                carrierName: "AMZN_US"
                            },
                            reverseTrackingInfo: []
                        },
                        marketplace_channel_details: {
                            channel_sku: '',
                            merchant_id: '',
                            shipment_id: '',
                            customer_order_id: '',
                            exchange_order_id: '',
                            return_location_id: '',
                            marketplace_channel: []
                        }
                    },
                    created_at: '',
                    updated_at: '',
                }
            }
        }
    },

    data() {
        return {
            loading: false
        }
    },

    methods: {
        acceptReturn(quantity) {
            this.loading = true;
            this.$inertia.post(this.$route('order.items.returns', [this.store.id, this.order.url_key]), {
                order_refund_id: this.orderRefund.id,
                effective: true,
                reason: 'sellable',
                quantity: quantity
            }, {
                onFinish: visit => {
                    this.loading = false;
                }
            })
        },

        rejectReturn(reason, quantity) {
            this.loading = true;
            this.$inertia.post(this.$route('order.items.returns', [this.store.id, this.order.url_key]), {
                order_refund_id: this.orderRefund.id,
                effective: true,
                reason: reason,
                quantity: quantity
            }, {
                onFinish: visit => {
                    this.loading = false;
                }
            })
        }
    },

    computed: {
        orderItem() {
            return this.orderRefund.items[0];
        }
    }
}
</script>
